import request from '@/utils/request'

export default {
  getList() {
    return request.get('/major/list')
  },
  getMajorList(page, size, keyword, collegeId) {
    return request.get('/major/list', {
      params: { page, size, keyword, collegeId }
    })
  },
  add(data) {
    return request.post('/major/add', data)
  },
  update(data) {
    return request.put('/major/update', data)
  },
  delete(id) {
    return request.delete(`/major/delete/${id}`)
  }
}
